import { render } from "./SalesStats.vue?vue&type=template&id=005bc671&scoped=true"
import script from "./SalesStats.vue?vue&type=script&lang=js"
export * from "./SalesStats.vue?vue&type=script&lang=js"

import "./SalesStats.vue?vue&type=style&index=0&id=005bc671&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005bc671"]])

export default __exports__